import { FormControl } from '@angular/forms';

import { ModalResultEnum } from '@connect-services/client/models/common.model';
import { FieldInterventionExportDto, FieldInterventionForm, Person } from '@connect-services/client/sdk/api';
import { FormGroupType } from '@shared/client/models/form.model';

export type Format = 'advancedXlsx' | 'Geopackage' | 'KMZ' | 'Shapefile' | 'XLSX';
export const Format = {
    ADVANCED_XLSX: 'advancedXlsx' as Format,
    GEOPACKAGE: 'Geopackage' as Format,
    KMZ: 'KMZ' as Format,
    SHAPEFILE: 'Shapefile' as Format,
    XLSX: 'XLSX' as Format,
};

export interface ExportFormType extends FormGroupType {
    assignedPeoples: FormControl<Person[]>;
    endDate: FormControl<Date | null>;
    formats: FormControl<Format[]>;
    forms: FormControl<FieldInterventionForm[]>;
    includeUpdatedEntities: FormControl<boolean>;
    intervenedPeoples: FormControl<Person[]>;
    startDate: FormControl<Date | null>;
    status: FormControl<FieldInterventionExportDto.StatusEnum[]>;
}

export type ExportModalReturnType = Omit<FieldInterventionExportDto, 'id'> & {
    type: ModalResultEnum;
};
